import { atom } from 'recoil';
import { FrontendSettings } from '../interfaces/Settings/FrontendSettings';

export const frontendSettingsAtom = atom<FrontendSettings>({
  key: 'frontendSettings',
  default: {
    settingsV1: {},
    storeSettings: {},
    availableLocales: [],
    menu: [],
    footer1: [],
    footer2: [],
  },
});
